export const TELEFONIA_MOVEL = "TELEFONIA MOVEL"



// WEBPACK FOOTER //
// ./src/services/state/sharedData/constants.js